module.exports = __webpack_public_path__ + "images/花筑奢pr长图_09.jpg?v=624f48bb";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_09.jpg
 ** module id = 49
 ** module chunks = 1 2
 **/